import { StyledEditFarmDrawer } from './style';

interface EditFarmDrawerProps {
  isEditFarmDrawerOpen: boolean;
  setEditFarmDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  children?: React.ReactNode;
  id?: string;
  footer?: JSX.Element;
  closeIcon?: React.ReactNode;
}

const EditFarmDrawer = ({
  isEditFarmDrawerOpen,
  setEditFarmDrawer,
  children,
  footer,
  closeIcon,
}: EditFarmDrawerProps) => {
  const closeDrawer = () => {
    setEditFarmDrawer(false);
  };

  return (
    <StyledEditFarmDrawer
      width={1250}
      open={isEditFarmDrawerOpen}
      onClose={closeDrawer}
      footer={footer}
      closeIcon={closeIcon}
    >
      {children}
    </StyledEditFarmDrawer>
  );
};

export default EditFarmDrawer;
